import { Box, Icon, Input, useOutsideClick, Text, Flex } from '@chakra-ui/react'
import { ChangeEvent, KeyboardEvent, useRef, useState } from 'react'
import Close from '../../../../components/Icon/Close'
import { get } from '../../../../lib/http'
import Item from '../../../../models/item'

interface Props {
    onSelect: (Item: any | null) => void
}

export default function FieldSearchItem({ onSelect }: Props) {
    const ref = useRef<HTMLInputElement>(null)
    const [search, setSearch] = useState('')
    const [isOpen, setIsOpen] = useState(false)
    const [index, setIndex] = useState(0)
    const [items, setItems] = useState<any[]>([])

    useOutsideClick({
        ref,
        handler: () => {
            setTimeout(() => setIsOpen(false), 100)
        }
    })

    async function searchHandler(ev: ChangeEvent<HTMLInputElement>) {
        setSearch(ev.target.value)
        const value = ev.target.value.trim().toLowerCase()
        if (!value) {
            setIsOpen(false)
            setItems([])
            setIndex(0)

            return
        }

        const url = `/api/items?search=${value}&limit=20&type=1`

        setIsOpen(true)
        const { data } = await get<Array<Item>>(url)

        if (data) {
            setItems(data.result)
            setIndex(_index =>
                data.result.length - 1 > _index
                    ? _index
                    : data.result.length - 1
            )
        }
    }

    const getData = (_combo: any) => {
        return _combo
    }

    function keyHandler(ev: KeyboardEvent<HTMLInputElement>) {
        ev.stopPropagation()

        if (ev.code === 'ArrowUp') {
            setIndex(_index => (_index === 0 ? 0 : _index - 1))
        }
        if (ev.code === 'ArrowDown') {
            setIndex(_index => (_index === items.length ? _index : _index + 1))
        }
        if (ev.code === 'Enter' || ev.code === 'NumpadEnter') {
            ev.preventDefault()
            setIsOpen(false)
            const findItem = items.find((_, i) => i === index)
            if (findItem) {
                onSelect(getData(findItem))
            } else {
                onSelect(null)
            }

            setIndex(0)
            setItems([])
            setSearch('')
        }
        if (ev.code === 'Escape') {
            setIsOpen(false)
            onSelect(null)
            setIndex(0)
            setItems([])
            setSearch('')
        }
    }

    function clearHandler() {
        setSearch('')
        onSelect(null)
        if (ref.current) {
            ref.current.focus()
        }
    }

    return (
        <Box position="relative" w="full">
            <Input
                placeholder="🏸 Buscar por nombre"
                mr={2}
                ref={ref}
                bg="white"
                onChange={searchHandler}
                onKeyDown={ev => keyHandler(ev)}
                value={search}
                type="text"
            />
            {search && (
                <Icon
                    as={Close}
                    fill="gray-3"
                    position="absolute"
                    top="calc(50% - 7px)"
                    right="4"
                    fontSize="sm"
                    cursor="pointer"
                    zIndex="1"
                    onClick={clearHandler}
                />
            )}
            <Box
                position="absolute"
                top={12}
                zIndex={10}
                py={2}
                bg="white"
                borderRadius="md"
                boxShadow="md"
                w="full"
                minW="72"
                borderWidth="1px"
                display={isOpen && items.length > 0 ? 'block' : 'none'}
            >
                {items.map((_item, i) => (
                    <Flex
                        key={_item.id}
                        py="2"
                        px="4"
                        bg={i === index ? 'gray.100' : 'white'}
                        cursor="pointer"
                        _hover={{
                            bg: i === index ? 'gray.100' : 'gray.50'
                        }}
                        justify="space-between"
                        align="center"
                        onClick={() => {
                            onSelect(getData(_item))
                            setSearch('')
                        }}
                    >
                        <Text>
                            {_item?.production_item?.name ?? _item?.name}
                        </Text>
                    </Flex>
                ))}
            </Box>
        </Box>
    )
}
